// extracted by mini-css-extract-plugin
export var dividerLine = "_an-3";
export var itemImage = "_an-9";
export var lightDivider = "_an-4";
export var modalContent = "_an-5";
export var modalContentCompact = "_an-6";
export var productCard = "_an-a";
export var productImage = "_an-b";
export var productImageCompact = "_an-7";
export var productImagePlaceholder = "_an-c";
export var productImagePlaceholderCompact = "_an-8";
export var progressBarBackground = "_an-1";
export var progressBarContainer = "_an-0";
export var progressBarFill = "_an-2";